// ============================================================================
// SUFFIX TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'suffix-tree',
  name: 'Suffix Tree',
  category: 'Strings',
  complexity: {
    time: 'O(N)',
    space: 'O(N)'
  },
  description: 'A compressed trie of all suffixes of a string. It enables efficient string operations like pattern matching, longest common substring, and longest repeated substring in linear time.'
};
